const state = {
  sidebarIsOpen: false,
  swipeDir: 'none'
}

const getters = {
  getSidebarIsOpen: (state) => {
    return state.sidebarIsOpen
  },
  getSidebarIsClose: (state) => {
    return state.sidebarIsOpen
  },
  getSwipeDir: (state) => {
    return state.swipeDir
  }
}

const actions = {
  openSidebar ({ commit }) {
    commit('SET_sidebarIsOpen')
  },
  closeSidebar ({ commit }) {
    commit('SET_sidebarIsClose')
  },
  detectSwipeDir ({ commit }, dir) {
    commit('SET_swipeDir', { dir })
  }
}

const mutations = {
  SET_sidebarIsOpen (state) {
    state.sidebarIsOpen = true
  },
  SET_sidebarIsClose (state) {
    state.sidebarIsOpen = false
    state.swipeDir = 'none'
  },
  SET_swipeDir (state, { dir }) {
    state.swipeDir = dir.dir
    if (dir.dir) {
      state.sidebarIsOpen = false
    } else {
      state.sidebarIsOpen = true
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js